import styled from 'styled-components';

export const ToastContainer = styled.div`
    height: 4rem;
    border-radius: 5rem;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.1);
    background-color: rgba(0, 0, 0, 0.7);
    position: absolute;
    left: 50%;
    bottom: 12.7rem;
    color: #fff;
    font-size: 1.4rem;
    line-height: 4rem;
    padding: 0 1.9rem;
    transform: translateX(-50%);
    white-space: nowrap;
    max-width: calc(100vw - 3.2rem);
    text-overflow: ellipsis;
    overflow: hidden;
    display: flex;
    align-items: center;
`;

export const MultipleLineContainer = styled.div`
    margin-top: 65rem;
    position: absolute;
    bottom: 12.7rem;
    left: 0;
    padding: 0 3.65rem;
`

export const MultipleLineContent = styled.div`
    display: flex;
    margin: 0 auto;
    align-items: center;
    padding: 1rem 2rem;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 5rem;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.1);
    background-color: rgba(0, 0, 0, 0.7);
    color: #fff;
    line-height: 2rem;
    font-size: 1.4rem;
`
